<script>
    export let toggled = false;
    export let clickFunc = function() {
        return;
    }
</script>

<div class={(toggled) ? "container ct" : "container"} on:click={clickFunc} >
    <div class={(toggled) ? "inner it" : "inner"}></div>
</div>

<style>
    .container {
        background-color: var(--light-grey);
        width: 50px;
        border-radius: 14px;
        -webkit-transition: all var(--fast);
        transition: all var(--fast);
    }

    .container:hover {
        cursor: pointer;
    }

    .ct {
        background-color: var(--primary);
    }

    .inner {
        background-color: var(--white);
        width: 20px;
        height: 20px;
        border-radius: 10px;
        margin: 4px;
        -webkit-transition: all var(--fast);
        transition: all var(--fast);
    }

    .it {
        -webkit-transform: translateX(22px);
        -ms-transform: translateX(22px);
        transform: translateX(22px);
    }
</style>
